import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from "../utils/MobileUtils";
import TrackingComponent from './TrackingComponent';

export default class LookbookProductCard extends Component {

  get SELECTORS() {
    return {
      select: '.sizes-select-modal',
      productCard:".product-card__img-container"
    }
  }

  constructor(el) {
    super(el);
    this.select = this.$component.querySelector(this.SELECTORS.select);
    this.productCard = this.$component.querySelector(this.SELECTORS.productCard)
    this.trackingComponent = new TrackingComponent();
  }

  initSelect2() {
    if (this.select) {
      const selectEl = $(this.select);
      $(selectEl).select2({
        resolve: 'width',
        minimumResultsForSearch: -1,
        placeholder: this.select.dataset.placeholder || '',
        containerCssClass: 'custom-dt-container',
        dropdownCssClass: 'custom-dt-dropdown',
        escapeMarkup: (markup) => {
          return markup;
        },
        templateSelection: (option) => {
          if (option.element) {
            return `<div><span>${option.text}</span></div>`;
          } else {
            return option.text;
          }
        },
        templateResult: (option) => {
          if (option.element) {
            if (option.element.dataset.notAvailable == 'true') {
              return;
            }
            return option.text;
          }  
        },
      })

      selectEl.on('select2:open', () => {
        if (isMobile(MobileBreakpoint.Max1023)) {
          if ($(selectEl).data('placeholder')) {
            // if any present from previous selection, remove
            $('.select2-results .divider').each(function () {
              $(this).remove();
            });
            $('.select2-results .mobile-placeholder').each(function () {
              $(this).remove();
            });
            // add placeholder and divider to mobile selection
            return $('.select2-results__options').before("<div class='divider'></div></div><div class='mobile-placeholder'>" + $(selectEl).data('placeholder') + "</div>")
          } else return;
        }
      });
    }
  }

  bindEvents() {
    if (this.productCard) {
      this.productCard.addEventListener('click', (e) => {
        e.preventDefault();
        const link = e.target.closest('a');
        this.trackingComponent.actions.lookView("",this.productCard);
        if (link) {
          window.location.href = link;
        }
      });
    }
    this.$on(this.$customEvents.LB_MODAL_EVENTS.shown, () => {
      this.initSelect2();
    });
  }

  render() {
    this.bindEvents();
    this.log('Render LookbookProductCard...');
  }

}
